/**
 * EmptySlotPlaceholder - Placeholder for Empty Viewport Slots
 *
 * Displayed when a slot in the hanging protocol grid has no matching
 * series. The slot accepts any series via drag-and-drop from the
 * sidebar — radiologists pick whatever fits their reading style, not
 * just the originally-protocol'd phase. We avoid prescribing the
 * expected phase here so the placeholder reads as an open slot, not
 * a missing-data error.
 */

import React from "react";

export const EmptySlotPlaceholder: React.FC = () => {
  return (
    <div className="w-full h-full bg-black flex flex-col items-center justify-center">
      <div className="text-fg-muted text-sm font-medium mb-2">Empty slot</div>
      <div className="text-fg-muted text-xs">Drag a series here</div>
    </div>
  );
};

export default EmptySlotPlaceholder;
